export type WebsitetextVariant =
  | 'display'
  | 'heroTitle'
  | 'heroSubtitle'
  | 'title'
  | 'smallTitle'
  | 'smallerTitle'
  | 'body'
  | 'body-lg'
  | 'smallUppercase'

export const textVariantsData: Record<
  WebsitetextVariant,
  {
    class: string
    defaultHtmlTag: keyof HTMLElementTagNameMap
    style?: React.CSSProperties
  }
> = {
  display: {
    class:
      'font-size-0-not-small font-size-2 font-family-title font-weight-medium line-height-normal',
    defaultHtmlTag: 'h1',
  },

  heroTitle: {
    class:
      'font-size-1-not-small font-size-2 font-family-title font-weight-medium line-height-normal',
    defaultHtmlTag: 'h1',
  },
  heroSubtitle: {
    class: 'font-size-4 font-family-title',
    defaultHtmlTag: 'div',
  },
  title: {
    class:
      'font-size-2 font-family-title font-weight-medium line-height-normal',
    defaultHtmlTag: 'h2',
  },
  smallTitle: {
    class: 'font-size-3 font-weight-semibold line-height-title',
    defaultHtmlTag: 'h3',
  },
  smallerTitle: {
    class: 'font-size-6 font-weight-bold line-height-title',
    defaultHtmlTag: 'h3',
  },
  body: {
    class: 'font-size-6 line-height-large',
    defaultHtmlTag: 'p',
  },
  'body-lg': {
    class: 'font-size-4 line-height-large',
    defaultHtmlTag: 'p',
  },
  smallUppercase: {
    class: 'font-size-7 uppercase font-weight-bold',
    defaultHtmlTag: 'p',
  },
}
